import styled from '@emotion/styled';
import React from 'react';

import CampaignFixedBar, {
  CampaignFixedBarProps
} from '../../Property/PropertyPage/CampaignFixedBar';
import FixedBottomBar from './FixedBottomBar';

const StyledFixedBottomBar = styled(FixedBottomBar)({
  marginBottom: '58px'
});

export type CampaignBottomBarProps = React.PropsWithChildren<
  Partial<CampaignFixedBarProps>
>;

const CampaignBottomBar: React.FC<CampaignBottomBarProps> = ({
  children,
  campaignLink,
  campaignLinkText,
  campaignBarText,
  ...rest
}) => {
  return (
    <React.Fragment>
      {campaignLink && campaignLinkText && campaignBarText ? (
        <div {...rest}>
          <StyledFixedBottomBar>{children}</StyledFixedBottomBar>
          <CampaignFixedBar
            campaignLink={campaignLink}
            campaignLinkText={campaignLinkText}
            campaignBarText={campaignBarText}
          />
        </div>
      ) : (
        <FixedBottomBar {...rest}>{children}</FixedBottomBar>
      )}
    </React.Fragment>
  );
};

export default CampaignBottomBar;
